import React from 'react';
import { ParametricSphereArt } from './ParametricSphereArt';
import { ParametricSphereArtTopo } from './ParametricSphereArtTopo';

interface TestbedProps {
  onBack?: () => void;
}

export const Testbed: React.FC<TestbedProps> = ({ onBack }) => {
  return (
    <div className="w-full min-h-screen bg-gray-900 flex flex-col items-center justify-center p-12">
      <h1 className="text-4xl font-seurat text-white mb-16">Parametric Sphere Visualizations</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 w-full max-w-7xl mx-auto">
        {/* Topographical Version */}
        <div className="flex flex-col items-center gap-6">
          <h2 className="text-xl font-seurat text-white">Topographical Contours</h2>
          <div className="w-96 h-96 bg-black border border-white border-opacity-30 rounded-lg flex items-center justify-center p-4">
            <ParametricSphereArtTopo width={360} height={360} dotSpacing={2.5} opacity={1} />
          </div>
          <p className="text-sm font-seurat text-gray-400 text-center max-w-sm">
            Animated topographical layers with pulsing and phase-shifting warping effect
          </p>
        </div>

        {/* Grid-based Globe Version */}
        <div className="flex flex-col items-center gap-6">
          <h2 className="text-xl font-seurat text-white">Grid Globe (Animated)</h2>
          <div className="w-96 h-96 bg-black border border-white border-opacity-30 rounded-lg flex items-center justify-center p-4">
            <ParametricSphereArt width={360} height={360} dotSpacing={2.5} opacity={1} />
          </div>
          <p className="text-sm font-seurat text-gray-400 text-center max-w-sm">
            Isometric grid with animated orbital paths and Lissajous curves
          </p>
        </div>
      </div>

      {onBack && (
        <button
          onClick={onBack}
          className="mt-16 px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded font-seurat transition-colors"
        >
          Back
        </button>
      )}
    </div>
  );
};
